import type { IconSize } from '@proton/icons/types';

const VpnPassLogo = ({ size = 15 }: { size?: IconSize }) => {
    return (
        <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon-size-${size}`}
            style={{ fill: 'white', color: 'white' }}
        >
            <g clipPath="url(#clip0_34952_8367)">
                <path
                    d="M0 11.1111C0 4.97461 4.97461 0 11.1111 0H28.8889C35.0254 0 40 4.97461 40 11.1111V28.8889C40 35.0254 35.0254 40 28.8889 40H11.1111C4.97461 40 0 35.0254 0 28.8889V11.1111Z"
                    fill="white"
                />
                <path
                    d="M11.1113 0.333008H28.8887C34.8411 0.333008 39.667 5.15893 39.667 11.1113V28.8887C39.667 34.8411 34.8411 39.667 28.8887 39.667H11.1113C5.15893 39.667 0.333008 34.8411 0.333008 28.8887V11.1113C0.333008 5.15893 5.15893 0.333008 11.1113 0.333008Z"
                    stroke="#ffffffff"
                    strokeOpacity="0.1"
                    strokeWidth="0.666667"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.311 25.5901C11.8135 26.4935 13.104 26.5424 13.6745 25.6797L18.9942 17.6356C19.5584 16.7826 19.0186 15.6389 17.997 15.5226L7.54098 14.3329C6.42621 14.2061 5.63248 15.3816 6.1747 16.3563L6.21722 16.4324L10.8828 19.6293L10.8261 24.7151L11.311 25.5901Z"
                    fill="url(#paint0_linear_34952_8367)"
                />
                <path
                    d="M11.6105 24.7475L12.0826 24.0434L15.6687 18.6263C15.9823 18.1527 15.683 17.5173 15.1157 17.4522L6.21582 16.4304L10.8262 24.7188C10.9945 25.0154 11.4199 25.0317 11.6105 24.7475Z"
                    fill="url(#paint1_radial_34952_8367)"
                />
                <path
                    d="M25.0312 15.6002C25.9148 14.7166 26.3566 14.2747 26.8661 14.1092C27.3142 13.9636 27.797 13.9636 28.2451 14.1092C28.7546 14.2747 29.1964 14.7166 30.08 15.6002L32.2889 17.809C33.1725 18.6927 33.6143 19.1345 33.7798 19.6439C33.9255 20.0921 33.9255 20.5748 33.7798 21.0229C33.6143 21.5324 33.1725 21.9742 32.2889 22.8578L30.08 25.0667C29.1964 25.9503 28.7546 26.3921 28.2451 26.5577C27.797 26.7033 27.3142 26.7033 26.8661 26.5577C26.3566 26.3921 25.9148 25.9503 25.0312 25.0667L24.6159 24.6011C24.3646 24.3194 24.239 24.1785 24.1494 24.0183C24.0699 23.8762 24.0116 23.7233 23.9763 23.5643C23.9365 23.3851 23.9365 23.1964 23.9365 22.8188L23.9365 17.8481C23.9365 17.4705 23.9365 17.2818 23.9763 17.1026C24.0116 16.9436 24.0699 16.7907 24.1494 16.6486C24.239 16.4884 24.3646 16.3475 24.6159 16.0658L25.0312 15.6002Z"
                    fill="url(#paint2_radial_34952_8367)"
                />
                <path
                    d="M25.0312 15.6002C25.9148 14.7166 26.3566 14.2747 26.8661 14.1092C27.3142 13.9636 27.797 13.9636 28.2451 14.1092C28.7546 14.2747 29.1964 14.7166 30.08 15.6002L32.2889 17.809C33.1725 18.6927 33.6143 19.1345 33.7798 19.6439C33.9255 20.0921 33.9255 20.5748 33.7798 21.0229C33.6143 21.5324 33.1725 21.9742 32.2889 22.8578L30.08 25.0667C29.1964 25.9503 28.7546 26.3921 28.2451 26.5577C27.797 26.7033 27.3142 26.7033 26.8661 26.5577C26.3566 26.3921 25.9148 25.9503 25.0312 25.0667L24.6159 24.6011C24.3646 24.3194 24.239 24.1785 24.1494 24.0183C24.0699 23.8762 24.0116 23.7233 23.9763 23.5643C23.9365 23.3851 23.9365 23.1964 23.9365 22.8188L23.9365 17.8481C23.9365 17.4705 23.9365 17.2818 23.9763 17.1026C24.0116 16.9436 24.0699 16.7907 24.1494 16.6486C24.239 16.4884 24.3646 16.3475 24.6159 16.0658L25.0312 15.6002Z"
                    fill="url(#paint3_linear_34952_8367)"
                />
                <path
                    d="M24.8734 15.7579C25.3152 15.316 25.5361 15.0951 25.7909 15.0124C26.0149 14.9396 26.2563 14.9396 26.4804 15.0124C26.7351 15.0951 26.956 15.316 27.3978 15.7579L30.7111 19.0711C31.1529 19.5129 31.3738 19.7339 31.4566 19.9886C31.5294 20.2127 31.5294 20.454 31.4566 20.6781C31.3738 20.9328 31.1529 21.1537 30.7111 21.5955L27.3978 24.9088C26.956 25.3506 26.7351 25.5715 26.4804 25.6543C26.2563 25.7271 26.0149 25.7271 25.7909 25.6543C25.5361 25.5715 25.3152 25.3506 24.8734 24.9088L22.8223 22.8577C21.9387 21.9741 21.4969 21.5323 21.3314 21.0228C21.1858 20.5747 21.1858 20.092 21.3314 19.6438C21.4969 19.1344 21.9387 18.6926 22.8223 17.8089L24.8734 15.7579Z"
                    fill="url(#paint4_radial_34952_8367)"
                />
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_34952_8367"
                    x1="17.9567"
                    y1="25.5895"
                    x2="9.44885"
                    y2="10.9176"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0660125" stopColor="#8EFFEE" />
                    <stop offset="0.4499" stopColor="#C9C7FF" />
                    <stop offset="1" stopColor="#7341FF" />
                </linearGradient>
                <radialGradient
                    id="paint1_radial_34952_8367"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(11.6227 12.6361) rotate(93.7553) scale(13.4997 17.4093)"
                >
                    <stop offset="0.403126" stopColor="#6D4AFF" />
                    <stop offset="0.9944" stopColor="#00F0C3" />
                </radialGradient>
                <radialGradient
                    id="paint2_radial_34952_8367"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(25.045 26.9137) rotate(-58.142) scale(10.5737 16.5352)"
                >
                    <stop stopColor="#FFD580" />
                    <stop offset="0.09375" stopColor="#F6C592" />
                    <stop offset="0.205" stopColor="#EBB6A2" />
                    <stop offset="0.324466" stopColor="#DFA5AF" />
                    <stop offset="0.42875" stopColor="#D397BE" />
                    <stop offset="0.53375" stopColor="#C486CB" />
                    <stop offset="0.64875" stopColor="#B578D9" />
                    <stop offset="0.77125" stopColor="#A166E5" />
                    <stop offset="0.89125" stopColor="#8B57F2" />
                    <stop offset="1" stopColor="#704CFF" />
                </radialGradient>
                <linearGradient
                    id="paint3_linear_34952_8367"
                    x1="24.6088"
                    y1="11.4849"
                    x2="27.0721"
                    y2="26.5215"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#6D4AFF" />
                    <stop offset="0.392009" stopColor="#B39FFB" stopOpacity="0.978022" />
                    <stop offset="1" stopColor="#FFE8DB" stopOpacity="0.8" />
                </linearGradient>
                <radialGradient
                    id="paint4_radial_34952_8367"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(24.1162 25.6262) rotate(-58.142) scale(8.50497 13.3)"
                >
                    <stop stopColor="#FFD580" />
                    <stop offset="0.09375" stopColor="#F6C592" />
                    <stop offset="0.205" stopColor="#EBB6A2" />
                    <stop offset="0.324466" stopColor="#DFA5AF" />
                    <stop offset="0.42875" stopColor="#D397BE" />
                    <stop offset="0.53375" stopColor="#C486CB" />
                    <stop offset="0.64875" stopColor="#B578D9" />
                    <stop offset="0.77125" stopColor="#A166E5" />
                    <stop offset="0.89125" stopColor="#8B57F2" />
                    <stop offset="1" stopColor="#704CFF" />
                </radialGradient>
                <clipPath id="clip0_34952_8367">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default VpnPassLogo;
